import { Box, makeStyles, Theme } from "@material-ui/core";
import { observer } from "mobx-react";

const useStyles = makeStyles((theme: Theme) => ({

}));

export const PayoffCardColumn = observer(({ width, textAlign, children }) => {
  const classes = useStyles();
  return (
    <Box style={{ width: width, textAlign: textAlign, padding: '0px 5px 0px 5px' }}>
      {children}
    </Box>
  )
});